module.exports = __webpack_public_path__ + "static/media/GYMPIE REGIONAL.db69dd7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_areas/GYMPIE REGIONAL.svg
// module id = 548
// module chunks = 0